<template>
  <div class="staff-record">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <div class="text-right mx-4 my-2">
          <v-btn @click="openAddDialog" rounded color="primary"> 
                Create Daily Report
          </v-btn>
        </div>
          <IntractDataTable
          title="Daily Reports"
          :headers="headers"
          :endpoint="endpointUrl"
          :filter-fields="filterFields()"
          search-parameter="query"
          order-parameter="o"
          :enable-pagination="true"
          @handleClick="handleClick"
          id="daily-reports-table"
          ref="dailyReportsTable"
        >
          <template v-slot:item.date="{ item }">
            <div>
              {{ moment(item.date).format("D MMMM YYYY") }}
            </div>
          </template>
          <!-- Date filter -->
          <template v-slot:custom-filter--date>
            <v-row>
              <v-col cols="12" :md="currentUser.privileges.canViewAllDailyReports ? 12 : 6">
                <div>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="dateRangeReports"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDateRange"
                        label="Filter by Report Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="rounded-input"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @change="getDailyReports"
                      v-model="dateRangeReports"
                      no-title
                      scrollable
                      range
                    >
                      <v-spacer></v-spacer>
                      <v-btn 
                        text color="red" @click="$refs.menu.save(null);dateRangeReports=null; getDailyReports()">Clear
                      </v-btn>
                      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(dateRangeReports)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
            
          </template>
          <template v-slot:item.report="{ item }">
            <div class="text-truncate" style="max-width: 255px;">
              {{item.report}}
            </div>
          </template>
        </IntractDataTable>
      </v-col>
    </v-row>

    <AddEditDailyReport 
      :dialog="dialog"
      :is_adding="is_adding"
      :is_editing="is_editing"
      :staff="currentUser.privileges.canEditAllDailyReports ? staff : staff.filter(s => s.id == this.currentUser.id)"
      @closeDialog="closeDialog"
      :id="report_id"
      ref="addEditDailyReport"
      @deleteDailyReport = "deleteDailyReport"
    >

    </AddEditDailyReport>

    <v-row justify="center">
      <DeleteConfirmationDialog
        title="Are you sure you want to delete this Daily Report?"
        :visible="showDeleteDailyReportDialog"
        @deleteObject="deleteRecord"
      />
    </v-row>

    <!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import AddEditDailyReport from "@components/dailyReports/AddEditDailyReport.vue";
import IntractDataTable from "@components/widgets/generics/IntractDataTable";
import moment from 'moment';
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog.vue";

export default {
  name: "DailyReports",
  components: {
    AddEditDailyReport,
    IntractDataTable,
    DeleteConfirmationDialog,
  },
  data() {
    return {
      moment: moment,
      report_id: null,
      dateRangeReports: null,
      menu: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "user.full_name",
        },
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Report",
          align: "start",
          sortable: false,
          value: "report",
        },
      ],
      snackbar: {
        visible: false,
        text: "",
      },
			endpoints: endpoints,
      dialog: false,
      is_adding: false,
      is_editing: false,
      dailyReports: null,
      staff: null,
      showDeleteDailyReportDialog: false,
      currentDailyReportId: null,
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },

    getExportName() {
      return Helper.getExportName();
    },

    endpointUrl() {
      let url = endpoints.dailyReportsViewSet
      if(this.dateRangeReports){
        url = Helper.addUrlParams(url,[`date__gte=${this.dateRangeReports[0]}`,`date__lte=${this.dateRangeReports[1]}`])
      }
      if(!this.currentUser.privileges.canViewAllDailyReports){
        url = Helper.addUrlParams(url,[`user__in=${this.currentUser.id}`]);
      }
      return url;
    },

    formattedDateRange() {
      if (!this.dateRangeReports) return;
      var formatted =
        moment(this.dateRangeReports[0]).format("D MMM, YYYY") +
        " - " +
        moment(this.dateRangeReports[1]).format("D MMM, YYYY");
      return formatted;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    
    filterFields() {
      if(!this.currentUser.privileges.canViewAllDailyReports){
        return{
          date: {
            isCustom: true,
          },
        }
      }
      return{
        user: {
          // model: !this.currentUser.privileges.canViewAllDailyReports? [Helper.clone(this.currentUser),]:null,
          items: !this.currentUser.privileges.canViewAllDailyReports?[this.currentUser,]:[],
          label: "Filter by Faculty",
          itemValue: "id",
          itemText: "full_name",
          param: "user__in",
          endpoint: this.currentUser.privileges.canViewAllDailyReports?Helper.addUrlParams(endpoints.getAllStaff,'all=true'):null,
        },
        date: {
          isCustom: true,
        },
      }  
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    async getAllStaff() {
      var response;
      var url = Helper.addUrlParams(endpoints.getAllStaff,'all=true');

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });

      if (response) {           
          this.staff = response;
        }     
        console.log(this.staff);
      },

    handleClick(value) {
      this.$refs.addEditDailyReport.handleClick(value.id);
      this.report_id = value.id;
      this.is_editing = false;
      this.dialog = true;
    },

    openAddDialog() {
      this.is_adding = true;
      this.is_editing = false;
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.is_adding = false;
      this.$refs.dailyReportsTable.getAllItems();
    },

    deleteDailyReport(id) {
      this.showDeleteDailyReportDialog = true;
      this.currentDailyReportId = id;
    },

    async deleteRecord(confirm) {
      this.showDeleteDailyReportDialog = false;
      var url = endpoints.dailyReportsViewSet;
      var response;
      if (confirm) {
        url += `${this.currentDailyReportId}/`;
        response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if (response) {
          this.snackbar.color = "dark";
          this.snackbar.text = "Daily Report deleted successfully";
          this.snackbar.visible = true;
          this.currentDailyReportId = null;
          this.closeDialog();
        }
      }
    }
  },
  created() {
      // this.handleTour();
      this.getAllStaff();
    },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>